import {Card} from 'antd'
const {Meta} = Card
import React from 'react'
import './plantsGallery.less'

export type PlantCardProps = {
  key?: number
  photo: string
  sun: number
  watering: number
  name: string
  description: string
}

export function PlantCard({photo, sun, watering, name, description}: PlantCardProps) {
  return (
    <Card
      className="plant-card"
      hoverable
      style={{width: 300, minHeight: 200, margin: 10, height: '100%'}}
      cover={<img style={{width: 300, height: 200, objectFit: 'cover'}} alt="image" src={photo} />}
    >
      <Meta title={name} description={description} />
    </Card>
  )
}
